(ns ycweb.app.admin.marketing.leads
  (:require
   [rum.core :as rum]
   [ycweb.util.date :as ud]
   [ycweb.app.dashboard.common :as dcommon]
   [ycweb.components.buttons :as buttons]
   [ycweb.app.website.common.facebook :as fb]
   [ycweb.components.common :as cmn]
   [ycweb.components.datatables.datatables :as datatables]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.transitions :as t]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as yuc]))

(defn data-source-parameters [app-atom]
  (let [campaign (rum/cursor-in app-atom [:marketing :campaign])]
    {:campaign-id (:id @campaign)}))

(rum/defc file-upload < rum/reactive [app-atom cfg]
  (let [campaign-atom (rum/cursor-in app-atom [:marketing :campaign])
        campaign (rum/react campaign-atom)]
    [:div
     (forms/fileupload "Upload File" "Upload a CSV file"
       (rum/cursor campaign-atom :image)
       {:path (str "/api/marketing/campaign/" (:id campaign) "/leads-upload")
        :name "lead-upload"
        :allowed-types (yuc/get-allowed-types :csv)})]))

(def leads-grid-fn
  {:data-source-fns
   {:campaign-fn (partial data-source-parameters)}
   :button-fns
   {:upload-fn (partial file-upload)}})

(def leads-grid-config
  {:table-name :marketing-leads-grid
   :row-id :marketing-lead/id
   :data-source
   {:end-point :admin.marketing/list-leads
    :parameter-fn :campaign-fn}
   :options
   {:order :desc
    :paging? true
    :pagination {:page 0 :page-size 20}
    :sort-title "Date Added"}
   :buttons
   [:refresh
    {:text "Import Leads"
     :component-fn :upload-fn}]
   :column-defs
   [{:key :marketing-lead/customername
     :title "Customer"}
    {:key :marketing-lead/email
     :title "E-mail"}
    {:key :marketing-lead/source
     :title "Source"}
    {:key :marketing-lead/status
     :title "Status"
     :align-class :u-text-center}
    {:key :marketing-lead/dateadded
     :title "Date Added"
     :type :date
     :align-class :u-text-right}]})

(defmethod comms/receive :admin.marketing.leads/facebook-long-live-page-token [app-atom {:keys [fb-response]}]
  (let [process-atom (cmn/process-cursor app-atom)]
    (println fb-response)))

(defmethod grid/action :marketing.lead/long-live-page-access-token [app-atom {:keys [user-access-token fb-user-id]}]
  (let [process-atom (cmn/process-cursor app-atom)]
    (comms/send :admin.marketing.leads/facebook-long-live-page-token
      {:user-access-token user-access-token
       :fb-user-id fb-user-id})))

(defmethod comms/receive :admin.marketing.leads/facebook-long-live-user-token [app-atom {:keys [fb-response]}]
  (let [process-atom (cmn/process-cursor app-atom)]
    (swap! process-atom update :facebook
      (fn [facebook]
        (assoc-in facebook [:tokens :user]
          {:long-lived
           {:access-token (:access_token fb-response)
            :token-expiration-datetime (:data_access_expiration_time fb-response)}})))))

(defmethod grid/action :marketing.lead/long-live-user-access-token [app-atom {:keys [user-access-token]}]
  (let [process-atom (cmn/process-cursor app-atom)]
    (comms/send :admin.marketing.leads/facebook-long-live-user-token {:user-access-token user-access-token})))

(defmethod grid/action :marketing.lead/disconnect-facebook [app-atom {:keys []}]
  (let [process-atom (cmn/process-cursor app-atom)]
    (fb/logout
      (fn [logout-response]
        (println logout-response)
        (swap! process-atom update :facebook
          (fn [facebook]
            (assoc facebook :status "logged_out")))))))

(defn update-facebook-atom [facebook response]
  (assoc facebook
    :status (:status response)
    :facebook-user-id (:userID response)
    :tokens
    {:user
     {:short-lived
      {:access-token (:accessToken response)
       :token-expiration-datetime (:data_access_expiration_time response)}}}))

(defmethod grid/action :marketing.lead/connect-facebook [app-atom {:keys []}]
  (toaster/open-overlay app-atom :web.login/user-login)
  (let [process-atom (cmn/process-cursor app-atom)]
    (fb/get-login-status
      (fn [status-response]
        (case (:status status-response)
          "connected"
          (swap! process-atom update :facebook #(update-facebook-atom % status-response))

          ;; else
          (fb/login
            (fn [login-response]
              (swap! process-atom update :facebook #(update-facebook-atom % login-response)))
            {:scope "public_profile,email,user_gender,user_birthday"}))))))

(rum/defc facebook-tokens < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        facebook-atom (rum/cursor process-atom :facebook)
        fb-status (cmn/curact facebook-atom :status)
        fb-user-id (cmn/curact facebook-atom :facebook-user-id)
        user-token-atom (rum/cursor-in facebook-atom [:tokens :user])
        short-token-expiration-datetime
        (ud/from-php-date (cmn/curact user-token-atom [:short-lived :token-expiration-datetime]))
        short-user-access-token (cmn/curact user-token-atom [:short-lived :access-token])
        long-user-access-token (cmn/curact user-token-atom [:long-lived :access-token])]
    [:div
     {:style
      {:border "1px solid #000"
       :display "block"
       :padding "10px 10px 25px 10px"
       :margin-bottom "50px"}}
     [:p "Dev only. Currently creates short -> long access tokens. Then page access tokens.
     Ground work for managing these tokens via a UI"]
     [:p "Facebook status: " (or fb-status "Unknown")]
     (cond
       (= fb-status "connected")
       (buttons/button-web "Disconnect from Facebook"
         {:type :button
          :on-click
          #(grid/dispatch-action app-atom :marketing.lead/disconnect-facebook {})
          :style :facebook
          :size :default
          :full true
          :icon :facebook})

       :else
       (buttons/button-web "Connect to Facebook"
         {:type :button
          :on-click
          #(grid/dispatch-action app-atom :marketing.lead/connect-facebook {})
          :style :facebook
          :size :default
          :full true
          :icon :facebook}))
     (when short-user-access-token
       [:div
        {:style {:margin-top "50px" :margin-bottom "25px"}}
        [:div
         "Short Lived User Access Token Generated. Expires at: "
         (ud/format-date short-token-expiration-datetime "dd/mm/yyyy hh:mm:ss")]
        (buttons/button-web "Generate Long Lived User Access Token"
          {:type :button
           :on-click
           #(grid/dispatch-action app-atom :marketing.lead/long-live-user-access-token
              {:user-access-token short-user-access-token})
           :style :facebook
           :size :default
           :full true
           :icon :facebook})])
     (when long-user-access-token
       [:div
        {:style {:margin-top "50px" :margin-bottom "25px"}}
        [:div
         "Long Lived User Access Token Generated."]
        (buttons/button-web "Generate Long Lived Page Access Token"
          {:type :button
           :on-click
           #(grid/dispatch-action app-atom :marketing.lead/long-live-page-access-token
              {:user-access-token long-user-access-token :fb-user-id fb-user-id})
           :style :facebook
           :size :default
           :full true
           :icon :facebook})])]))

(rum/defc overview < rum/reactive [app-atom]
  (let [marketing-atom (rum/cursor app-atom :marketing)
        campaign (cmn/curact marketing-atom :campaign)]
    [:div
     (when (cmn/has-permission? app-atom "SiteAdmin:Teams:Development")
       (facebook-tokens app-atom))
     [:div.u-min-height-160
      (forms/form-field
        "Campaigns"
        {}
        (forms/inline-autocomplete-field
          (if campaign
            [:span.u-block.u-margin-top-12.faux-input-combo__placeholder (str (:campaign-name campaign))]
            [:span.u-block.u-margin-top-12.faux-input-combo__placeholder "Search for a Campaign"])
          (rum/cursor-in marketing-atom [:search :results])
          {:select-style? true
           :empty-list-hint "No campaigns found."
           :min-count 2
           :item-render-fn
           (fn [item] (:name item))

           :change-fn
           #(grid/dispatch-action app-atom
              :marketing.lead/campaign-search
              {:search %})

           :select-fn
           #(grid/dispatch-action app-atom
              :marketing.lead/refresh-leads
              {:id (:id %)
               :campaign-name (:name %)})}))
      (headings/heading "Marketing Leads" {:type :h2 :size :medium})
      (datatables/table app-atom :marketing-leads-grid leads-grid-fn)]]))

(defmethod grid/action :marketing.lead/campaign-search [app-atom {:keys [search]} _]
  (let [search-atom (rum/cursor-in app-atom [:marketing :search])]
    (swap! search-atom assoc :input search)
    (comms/send :admin.marketing.leads/search-campaigns {:search search})))

(defmethod grid/action :marketing.lead/refresh-leads [app-atom campaign _]
  (swap! app-atom update :marketing assoc :campaign campaign)
  (datatables/refresh app-atom :marketing-leads-grid leads-grid-fn))

(defmethod comms/receive :admin.marketing.leads/search-campaigns [app-atom {:keys [term campaigns]}]
  (let [marketing-atom (rum/cursor app-atom :marketing)]
    (when (= term (get-in @marketing-atom [:search :input]))
      (swap! marketing-atom assoc-in [:search :results] campaigns))))

(defmethod flow/render-screen :admin.marketingleads [app-atom _]
  (overview app-atom))

(defmethod t/transition-open :admin.marketingleads [app-atom _ _]
  (comms/send :admin.marketing.leads/init-facebook {}))

(defmethod t/transition-after-open :admin.marketingleads [app-atom _ _]
  (let  [process-atom (cmn/process-cursor app-atom)
         facebook-atom (rum/cursor process-atom :facebook)]
    (dcommon/kill-search-bar)
    (datatables/initiate app-atom leads-grid-config leads-grid-fn)
    (fb/load-sdk
      #(fb/init
         {:appId (:login-app-id @facebook-atom)
          :status true
          :cookies true
          :xfbml true
          :version "v16.0"}))))

(defmethod comms/receive :admin.marketing.leads/init-facebook [app-atom {:keys [facebook]}]
  (let [process-atom (cmn/process-cursor app-atom)]
    (swap! process-atom assoc :facebook facebook)))

(defmethod comms/receive :admin.marketing/list-leads [app-atom e]
  (datatables/post-comms app-atom :marketing-leads-grid {:rows (:rows e)}))